import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function SiteHeader({ onToggleDrawer }) {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const timerRef = useRef(null);

  const handleSearch = (val) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (val.trim()) navigate(`/fatwas?q=${encodeURIComponent(val)}`);
    }, 500);
  };

  // Primary name in the active language, with a secondary line for context.
  // ar → Arabic primary + English subtitle
  // en → English primary + Arabic subtitle
  // ur → Urdu primary + English subtitle
  const primaryName = t('footer.name');
  const subtitleName =
    lang === 'ar' ? 'International Institute for Islamic Studies' :
    lang === 'en' ? 'المعهد الدولي للدراسات الإسلامية' :
                    'International Institute for Islamic Studies';

  return (
    <div className="site-header">
      <div className="header-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
        <img src="/images/iiis-logo.webp" className="logo-seal-img" alt="IIIS" width="48" height="48" />
        <div className="logo-names">
          <div className="ar">{primaryName}</div>
          <div className="en">{subtitleName}</div>
        </div>
      </div>
      <div className="header-search">
        <input
          type="text"
          ref={searchRef}
          placeholder={t('header.search.placeholder')}
          onChange={e => handleSearch(e.target.value)}
        />
        <button onClick={() => handleSearch(searchRef.current?.value || '')}>🔍</button>
      </div>
      <div className="header-actions">
        <button className="btn-ask"    onClick={() => navigate('/contact')}>{t('header.ask')}</button>
        <button className="btn-donate" onClick={() => navigate('/donate')}>{t('header.donate')}</button>
      </div>
      <button className="mob-menu-btn" onClick={onToggleDrawer}>
        <span /><span /><span />
      </button>
    </div>
  );
}
